import React, { memo, useMemo } from 'react';
import classnames from 'classnames';
import { useMemoizedFn } from 'ahooks';
import GPSelectMultiple from '@gp/components/SelectMultiple';
import GPSelect from '@gp/components/Select';
import { getOptionsWithSeparatedGroupKey, toFirstUpperCase } from '@gp/utils/common';
import { sourceOptionTextRenderer } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/renderers';
import '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Live/components/Filter/index.scss';

interface IFilterProps extends IBaseProps {
  projectFilterLoading: boolean;
  projects: IStudioOverallProject[];
  sources: IStudioOverallSource[];
  value: IStudioOverallProjectsDetailsLiveFilter;
  onChange: (value: IStudioOverallProjectsDetailsLiveFilter, filterName: string) => void;
}

const Filter: React.FC<IFilterProps> = (props) => {
  const {
    projectFilterLoading,
    projects: projectsProps,
    sources,
    value: valueProps,
    onChange,
    style,
    className,
    ...remains
  } = props;

  const projects = useMemo(
    () => getOptionsWithSeparatedGroupKey(projectsProps),
    [projectsProps],
  );

  const handleProjectsChange = useMemoizedFn((value) => {
    const newValue = {
      ...valueProps,
      projects: value || [],
    };
    onChange?.(newValue, 'project');
  });

  const handleSourceChange = useMemoizedFn((value) => {
    const newValue = {
      ...valueProps,
      source: value || '',
    };
    onChange?.(newValue, 'source');
  });

  return (
    <div
      {...remains}
      style={style}
      className={classnames(
        'dbg-studio-overall-details-projects-live-filter',
        className,
      )}
    >
      <GPSelect
        label="Source"
        style={{ marginRight: 10 }}
        value={valueProps?.source}
        button={
          <>
            <span className="select-button-text">Source</span>
            <span className="select-button-value">
              {toFirstUpperCase(valueProps?.source)}
            </span>
          </>
        }
        optionTextRenderer={sourceOptionTextRenderer}
        options={sources}
        onChange={handleSourceChange}
      />
      <GPSelectMultiple
        label="Project"
        searchable
        disabled={projectFilterLoading}
        style={{ marginRight: 10 }}
        value={valueProps?.projects || []}
        options={projects}
        onChange={handleProjectsChange}
      />
    </div>
  );
};

export default memo(Filter);
